import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';
import ManagedInput from 'components/form/managed_input';

export default function CustomFieldFormTextOptions({ customField, onChange }) {
  if (customField.type !== 'text') {
    return null;
  }

  function addOption() {
    onChange({ options: [...customField.options || [], ''] });
  }

  function changeOption(value, i) {
    const options = [...customField.options];
    options[i] = value;
    onChange({ options });
  }

  function removeOption(i) {
    const options = [...customField.options];
    options.splice(i, 1);
    onChange({ options });
  }

  return (
    <div className="form-group">
      <label className="form-label">Dropdown options</label>
      {customField.options?.map((option, i) => (
        <div className="d-flex align-items-center mb-2" key={i}>
          <ManagedInput
            className="flex-grow-1 me-2 form-control"
            value={option}
            onValueChange={value => changeOption(value, i)}
          />
          <FontAwesomeIcon className="text-destructive" icon={faTrashAlt} onClick={() => removeOption(i)} />
        </div>
      ))}

      <div>
        <AddControl onClick={addOption}>Add option</AddControl>
      </div>
    </div>
  );
}

CustomFieldFormTextOptions.propTypes = {
  customField: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
